<template>
  <div class="archieved-requests">
    <v-btn
      v-if="selectedTab == 0"
      @click="handleFilterRateDialog"
      fab
      class="mx-2 pa-0 genaralIcons"
      small
      style="left: 80px"
      :color="$vuetify.theme.themes.light.BtnBKColor"
      depressed
      width="35"
      height="35"
    >
      <SearchIcon />
    </v-btn>

    <div
      v-if="$store.state.views === 'table'"
      style="margin-bottom: 40px"
      class="table__view"
    >
      <template>
        <v-tabs
          v-model="selectedTab"
          class="custom-tabs"
          style="margin-bottom: 50px; color: white"
        >
        
          <v-tab
            key="2"
            tab-value="2"
            class="custom-tab"
            :class="{ 'custom-tab--active': selectedTab == 2 }"
            @click="tabsFilter(2)"
            >تحت المعالجة</v-tab
          >

          <v-tab
            key="0"
            tab-value="0"
            class="custom-tab"
            :class="{ 'custom-tab--active': selectedTab == 0 }"
            @click="tabsFilter(0)"
            >تمت معالجتها</v-tab
          >
        </v-tabs>
      </template>

      <table-component
        :showSelect="true"
        itemKey="id"
        :selectedRows.sync="selected_requests"
        @refresh="get_archieved_requests"
        :headers="getHeaders"
        :items="this.$store.state.tableData"
        :loading="loading"
        v-model="page"
        :pagination="pagination"
        :limit="10"
      >
        <!-- eslint-disable -->

        <template v-slot:[`item.settings`]="{ item }">
          <div>
            <button
              class="accept-button"
              @click="approveArchivedRequest(item.request.id)"
              title="الموافقه علي أرشفة الطلب"
            >
              <i class="accept-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="25"
                  fill="currentColor"
                  class="bi bi-check"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M13.742 5.742a1 1 0 0 0-1.414 0L7 10.586l-2.828-2.828a1 1 0 0 0-1.414 1.414l3.535 3.536a1 1 0 0 0 1.415 0L14 7.157a1 1 0 0 0 0-1.415z"
                  />
                </svg>
              </i>
            </button>

            <button
              class="refuse-button"
              @click="cancelRequestFromarchived(item.request.id)"
              title="رفض أرشفة الطلب وتحويله للمستلمه"
            >
              <i class="refuse-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="25"
                  fill="currentColor"
                  class="bi bi-x"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M4.293 4.293a1 1 0 0 1 1.414 0L8 6.586l2.293-2.293a1 1 0 0 1 1.414 1.414L9.414 8l2.293 2.293a1 1 0 0 1-1.414 1.414L8 9.414l-2.293 2.293a1 1 0 0 1-1.414-1.414L6.586 8 4.293 5.707a1 1 0 0 1 0-1.414z"
                  />
                </svg>
              </i>
            </button>
          </div>
        </template>

        <template v-slot:[`item.action`]="{ item }">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="#3f0e40"
                depressed
                small
                dark
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <router-link
                style="text-decoration: none"
                :to="{
                  name: 'request_details',
                  params: { id: item.request.id },
                }"
              >
                <v-list-item>
                  <v-list-item-icon class="ml-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18.528"
                      height="15.111"
                      viewBox="0 0 13.528 10.111"
                    >
                      <g
                        id="Icon_feather-eye-dark"
                        data-name="Icon feather-eye-dark"
                        transform="translate(-1 -5.5)"
                      >
                        <path
                          id="Path_4040"
                          data-name="Path 4040"
                          d="M1.5,10.556S3.778,6,7.764,6s6.264,4.556,6.264,4.556-2.278,4.556-6.264,4.556S1.5,10.556,1.5,10.556Z"
                          fill="none"
                          :stroke="$store.getters.isDark ? '#fff' : '#2c2c2c'"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="1"
                        />
                        <path
                          id="Path_4041"
                          data-name="Path 4041"
                          d="M16.917,15.208A1.708,1.708,0,1,1,15.208,13.5,1.708,1.708,0,0,1,16.917,15.208Z"
                          transform="translate(-7.444 -4.653)"
                          fill="none"
                          :stroke="$store.getters.isDark ? '#fff' : '#2c2c2c'"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="1"
                        />
                      </g>
                    </svg>
                  </v-list-item-icon>
                  <v-list-item-title>فتح</v-list-item-title>
                </v-list-item>
              </router-link>

              <v-list-item @click="getRequestCalls(item)">
                <v-list-item-icon class="ml-3">
                  <RequestCallsIcon />
                </v-list-item-icon>
                <v-list-item-title>المكالمات</v-list-item-title>
              </v-list-item>

              <router-link
                style="text-decoration: none"
                target="_blank"
                :to="{
                  name: 'request_details',
                  params: { id: item.request.id },
                }"
              >
                <v-list-item>
                  <v-list-item-icon class="ml-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18.528"
                      height="15.111"
                      viewBox="0 0 13.528 10.111"
                    >
                      <g
                        id="Icon_feather-eye-dark"
                        data-name="Icon feather-eye-dark"
                        transform="translate(-1 -5.5)"
                      >
                        <path
                          id="Path_4040"
                          data-name="Path 4040"
                          d="M1.5,10.556S3.778,6,7.764,6s6.264,4.556,6.264,4.556-2.278,4.556-6.264,4.556S1.5,10.556,1.5,10.556Z"
                          fill="none"
                          :stroke="$store.getters.isDark ? '#fff' : '#2c2c2c'"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="1"
                        />
                        <path
                          id="Path_4041"
                          data-name="Path 4041"
                          d="M16.917,15.208A1.708,1.708,0,1,1,15.208,13.5,1.708,1.708,0,0,1,16.917,15.208Z"
                          transform="translate(-7.444 -4.653)"
                          fill="none"
                          :stroke="$store.getters.isDark ? '#fff' : '#2c2c2c'"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="1"
                        />
                      </g>
                    </svg>
                  </v-list-item-icon>
                  <v-list-item-title> فتح في تاب جديد</v-list-item-title>
                </v-list-item>
              </router-link>

              <v-list-item @click="to_tickets_page(item)">
                <v-list-item-icon class="ml-3">
                  <svg
                    class="ml-2"
                    xmlns="http://www.w3.org/2000/svg"
                    width="23.194"
                    height="23.212"
                    viewBox="0 0 23.194 23.212"
                  >
                    <g
                      id="ticket_menu"
                      data-name="ticket menu"
                      transform="translate(0)"
                    >
                      <path
                        id="Path_2758"
                        data-name="Path 2758"
                        d="M93.931,77.839a.631.631,0,0,0-.8-.076,2.521,2.521,0,0,1-3.493-3.506.638.638,0,0,0-.076-.795l-.725-.725A2.525,2.525,0,0,0,87.051,72h0a2.525,2.525,0,0,0-1.785.738L72.92,85.123a2.525,2.525,0,0,0,.006,3.563l.486.479a.636.636,0,0,0,.845.044,2.5,2.5,0,0,1,3.525,3.519.631.631,0,0,0,.038.851l.9.9a2.527,2.527,0,0,0,3.569,0h0l12.36-12.36a2.527,2.527,0,0,0,0-3.569ZM81.382,93.579a1.264,1.264,0,0,1-1.785,0l-.517-.517A3.758,3.758,0,0,0,73.929,87.9l-.107-.107a1.264,1.264,0,0,1,0-1.785l8.406-8.437,7.58,7.58Zm12.36-12.36L90.69,84.271l-7.58-7.586,3.039-3.052a1.24,1.24,0,0,1,.889-.372h0a1.26,1.26,0,0,1,.889.366l.385.385a3.788,3.788,0,0,0,5.064,5.064l.359.359a1.258,1.258,0,0,1,.006,1.785Z"
                        transform="translate(-72.187 -72)"
                        :fill="$route.name == 'tickets' ? '#fff' : '#2c2c2c'"
                      />
                      <path
                        id="Path_2759"
                        data-name="Path 2759"
                        d="M171.445,217.177l-3.058-3.058a1.264,1.264,0,0,0-1.785,0h0l-2.983,2.983a1.264,1.264,0,0,0,0,1.785l3.058,3.058a1.264,1.264,0,0,0,1.785,0l2.983-2.983a1.249,1.249,0,0,0,.032-1.772C171.47,217.177,171.463,217.171,171.445,217.177Zm-3.872,3.872-3.065-3.058,2.983-2.983h0l3.058,3.058Z"
                        transform="translate(-157.508 -204.811)"
                        :fill="$route.name == 'tickets' ? '#fff' : '#2c2c2c'"
                      />
                    </g>
                  </svg>
                </v-list-item-icon>
                <v-list-item-title>التذاكر</v-list-item-title>
              </v-list-item>
              <v-list-item @click="to_chat_page(item)">
                <v-list-item-icon class="ml-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="17.599"
                    height="18.22"
                    viewBox="0 0 17.599 18.22"
                  >
                    <g id="chat" transform="translate(-2.1 -1.2)">
                      <path
                        id="Path_2760"
                        data-name="Path 2760"
                        d="M11.565,37.775a3.256,3.256,0,0,0-2.366-1.6c-.769-.207-.739-.5-.71-.739l.059-.118a.029.029,0,0,1,.03-.03c.03-.059.089-.118.118-.177A1.807,1.807,0,0,0,8.9,34.7c.03-.059.03-.118.059-.177,0-.03.03-.059.03-.089l.089-.089.207-.237.03-.03a1.289,1.289,0,0,0,.177-.5v-.089c0-.089.03-.148.03-.237v-.177a.782.782,0,0,0-.3-.621.267.267,0,0,1,.03-.148,2.252,2.252,0,0,0,.089-.621,1.673,1.673,0,0,0-.237-.946,1.881,1.881,0,0,0-.8-.71c-.059-.03-.148-.059-.207-.089a3.218,3.218,0,0,0-1.183-.207H6.655a2.493,2.493,0,0,0-.887.177c-.03.03-.089.03-.089.059a1.023,1.023,0,0,0-.325.3l-.03.059c-.03.059-.03.059-.059.059a.394.394,0,0,1-.148.089.64.64,0,0,0-.355.325,1.889,1.889,0,0,0-.177.651,5.013,5.013,0,0,0,.03.651c0,.089.03.177.03.266v.03a.618.618,0,0,0-.325.621v.207c0,.089.03.177.03.237v.089a1.267,1.267,0,0,0,.148.473c.059.089.089.148.148.177a.784.784,0,0,0,.177.148,2.8,2.8,0,0,0,.325.739v.03l.03.03.059.089.03.03c.03.03.03.03.03.059l.03.03v.03c.03.207.089.5-.71.739a3.529,3.529,0,0,0-2.366,1.6,1.955,1.955,0,0,0-.148.769v.562a.392.392,0,0,0,.385.385h0a.392.392,0,0,0,.385-.385v-.532a1.854,1.854,0,0,1,.059-.473c.266-.621,1.183-.976,1.893-1.183q1.464-.4,1.242-1.6a.657.657,0,0,0-.148-.325l-.03-.03c0-.03-.03-.03-.03-.059L5.738,34.7a3.205,3.205,0,0,1-.237-.562.6.6,0,0,0-.237-.355l-.059-.03c-.03,0-.03-.03-.059-.059a.1.1,0,0,1-.03-.059.42.42,0,0,1-.059-.177l.059-.118c0-.059-.03-.118-.03-.177v-.089h.059l.089-.03a.462.462,0,0,0,.207-.385,1.746,1.746,0,0,0-.059-.414c0-.059-.03-.118-.03-.177a1.766,1.766,0,0,1,0-.562.636.636,0,0,1,.059-.3A1.221,1.221,0,0,0,5.738,31a.68.68,0,0,0,.207-.237l.03-.059a.231.231,0,0,1,.118-.118,2.1,2.1,0,0,1,.621-.118h.207a2.3,2.3,0,0,1,.917.177c.059.03.089.03.148.059a.821.821,0,0,1,.444.385,1.013,1.013,0,0,1,.118.532,2.589,2.589,0,0,1-.059.473,1.006,1.006,0,0,0-.03.3v.089a.505.505,0,0,0,.03.355.529.529,0,0,0,.3.266v.089a.375.375,0,0,1-.03.177.178.178,0,0,1-.03.118.25.25,0,0,1-.059.177l-.03.03-.059.03-.207.207a.879.879,0,0,0-.177.385c0,.03,0,.059-.03.059a2.748,2.748,0,0,1-.148.3c-.03.03-.03.059-.059.089l-.207.3a.557.557,0,0,0-.059.237q-.222,1.2,1.242,1.6a2.793,2.793,0,0,1,1.893,1.183,1.3,1.3,0,0,1,.059.473v.532a.373.373,0,0,0,.385.385h0a.392.392,0,0,0,.385-.385v-.562A1.135,1.135,0,0,0,11.565,37.775Zm-.237,1.568Zm8.37-.8a1.865,1.865,0,0,0-.148-.769,3.256,3.256,0,0,0-2.4-1.6c-.769-.207-.739-.5-.71-.739l.059-.148.03-.03c.03-.059.089-.118.118-.177a2.686,2.686,0,0,0,.207-.414,1.233,1.233,0,0,0,.059-.177V34.4c.03-.03.059-.059.089-.059l.03-.03.03-.03.177-.207.03-.03a1.289,1.289,0,0,0,.177-.5v-.089c0-.089.03-.148.03-.237v-.177a.782.782,0,0,0-.3-.621.267.267,0,0,1,.03-.148,2.607,2.607,0,0,0,.089-.621,1.673,1.673,0,0,0-.237-.946,1.881,1.881,0,0,0-.8-.71v-.03a.5.5,0,0,0-.148-.059,3.113,3.113,0,0,0-1.183-.207H14.67a2.06,2.06,0,0,0-.887.177c-.059.03-.089.059-.118.059a1.55,1.55,0,0,0-.325.3l-.03.089-.03.03a.029.029,0,0,1-.03.03.27.27,0,0,1-.148.089.64.64,0,0,0-.355.325,1.889,1.889,0,0,0-.177.651V32.1c0,.089.03.177.03.266v.03a.618.618,0,0,0-.325.621v.177a.912.912,0,0,0,.03.266v.089a2.216,2.216,0,0,0,.148.473c.059.059.089.148.148.177a.784.784,0,0,0,.177.148,2.43,2.43,0,0,0,.325.739v.03l.089.118.03.03c.03.03.03.03.03.059l.03.059c.03.207.089.5-.71.739a6.474,6.474,0,0,0-1.213.473l-.03.03a3.545,3.545,0,0,1,.5.621,5.782,5.782,0,0,1,.946-.355q1.464-.4,1.242-1.6a.657.657,0,0,0-.148-.325l-.03-.03c0-.03-.03-.03-.03-.059l-.118-.148a3.205,3.205,0,0,1-.237-.562.589.589,0,0,0-.237-.355l-.059-.03a.064.064,0,0,1-.059-.059.1.1,0,0,1-.03-.059.42.42,0,0,1-.059-.177l.089-.148c0-.059-.03-.118-.03-.177v-.089h.059l.089-.03a.4.4,0,0,0,.207-.385,1.79,1.79,0,0,0-.059-.444c0-.059-.03-.089-.03-.148a1.766,1.766,0,0,1,0-.562.742.742,0,0,1,.059-.3h0A1.99,1.99,0,0,0,13.724,31a1.293,1.293,0,0,0,.207-.237l.03-.059a.231.231,0,0,1,.118-.118,1.75,1.75,0,0,1,.592-.118h.207a2.3,2.3,0,0,1,.917.177c.059.03.089.03.148.059a.941.941,0,0,1,.444.385,1.013,1.013,0,0,1,.118.532,2.589,2.589,0,0,1-.059.473.819.819,0,0,0-.03.266v.089a.505.505,0,0,0,.03.355.529.529,0,0,0,.3.266v.089a.375.375,0,0,1-.03.177l-.03.118a.269.269,0,0,1-.089.207l-.03.089-.177.177a.842.842,0,0,0-.177.414c0,.03,0,.03-.03.059a1.363,1.363,0,0,1-.148.3c0,.03-.03.059-.059.089h-.03l-.089.148-.059.089v.059a.557.557,0,0,0-.059.237q-.222,1.2,1.242,1.6A2.793,2.793,0,0,1,18.87,38.1a1.34,1.34,0,0,1,.089.473v.532a.413.413,0,0,0,.089.266.321.321,0,0,0,.266.118h0a.373.373,0,0,0,.385-.385v-.118C19.7,38.6,19.7,38.544,19.7,38.544Z"
                        transform="translate(0 -20.07)"
                        fill="#383c40"
                      />
                      <path
                        id="Path_2761"
                        data-name="Path 2761"
                        d="M10.973,9.008a.467.467,0,0,1-.473-.473V3.359A2.168,2.168,0,0,1,12.659,1.2h.03c1.183.03,1.923,0,2.78,0h1.508a2.184,2.184,0,0,1,1.331.444,2.135,2.135,0,0,1,.858,1.627A4.13,4.13,0,0,1,18.9,5.1a3.371,3.371,0,0,1-.532.887A3.54,3.54,0,0,1,16.5,7.263a3.207,3.207,0,0,1-1.065.148H12.748L11.683,8.476l-.355.355A.416.416,0,0,1,10.973,9.008Zm1.686-7.069a1.444,1.444,0,0,0-1.449,1.42V7.973l1.035-1.035.03-.03a.584.584,0,0,1,.414-.177h2.751a3.849,3.849,0,0,0,.887-.118,3.017,3.017,0,0,0,1.479-1.035,2.622,2.622,0,0,0,.414-.739A4.216,4.216,0,0,0,18.427,3.3a1.346,1.346,0,0,0-.562-1.094,1.4,1.4,0,0,0-.887-.3H15.5c-.917.03-1.656.03-2.839.03Z"
                        transform="translate(-5.916)"
                        fill="#383c40"
                      />
                      <path
                        id="Path_2762"
                        data-name="Path 2762"
                        d="M41.568,3.511V8.6a.424.424,0,0,1-.148.325.445.445,0,0,1-.325.118.62.62,0,0,1-.325-.118l-.562-.562c-.3-.3-.562-.562-.769-.739H36.421a1.109,1.109,0,0,1-.325-.03l-.3-.03a5.069,5.069,0,0,0,.739-.651h2.928a.584.584,0,0,1,.414.177l.03.03.562.562.266.266.089.059v-4.5A1.3,1.3,0,0,0,39.5,2.21H37.279a2.04,2.04,0,0,0-.532-.71h2.78A2.035,2.035,0,0,1,41.568,3.511Z"
                        transform="translate(-23.732 -0.211)"
                        fill="#383c40"
                      />
                    </g>
                  </svg>
                </v-list-item-icon>
                <v-list-item-title>محادثة العميل</v-list-item-title>
              </v-list-item>

              <v-list-item @click="toOrderRequest(item)">
                <v-list-item-icon class="ml-2">
                  <OrderHistory />
                </v-list-item-icon>
                <v-list-item-title>سجل الطلب</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>

        <template slot="item.agent_date" slot-scope="props">
          <div>{{ props.item.request.agent_date.split(" ")[0] }}</div>
          <div>
            {{ props.item.request.agent_date.split(" ")[1].split(".")[0] }}
          </div>
        </template>

        <template slot="item.agent_notes" slot-scope="props">
          <span v-if="!props.item.request.agent_notes"></span>
          <v-tooltip bottom v-else>
            <template v-slot:activator="{ on }">
              <span v-on="on">{{
                props.item.request.agent_notes.substring(0, 25) + "..."
              }}</span>
            </template>
            <div class="font-weight-bold">
              {{ props.item.request.agent_notes }}
            </div>
          </v-tooltip>
        </template>

        <template slot="item.quality_notes" slot-scope="props">
          <span v-if="!props.item.request.quality_notes"></span>
          <v-tooltip bottom v-else>
            <template v-slot:activator="{ on }">
              <span v-on="on">{{
                props.item.request.quality_notes.substring(0, 25) + "..."
              }}</span>
            </template>
            <div class="font-weight-bold">{{ props.item.quality_notes }}</div>
          </v-tooltip>
        </template>
        <template slot="item.source" slot-scope="props">
          {{ work_source(parseInt(props.item.request.source))
          }}{{
            props.item.request.source == 2
              ? ` - ${props.item.request.collaborator_name}`
              : ""
          }}
        </template>
        <template slot="item.customer_name" slot-scope="props">
          {{ props.item.request.customer.name }}
        </template>

        <template slot="item.req_date" slot-scope="props">
          {{
            props.item.request?.created_at.split(".")[0].split("T").join(" | ")
          }}
        </template>
        <template slot="item.type" slot-scope="props">
          {{ props.item.request.type ||  "لا يوجد نوع طلب" }}
        </template>

        <template slot="item.date_in_quality" slot-scope="props">
          {{ props.item.created_at.split(".")[0].split("T").join(" | ") }}
        </template>

        <template slot="item.status" slot-scope="props">
          {{ props.item.request.status }}
        </template>

        <template slot="item.quality_user" slot-scope="props">
          {{ props.item.qualityUser.name }}
        </template>

        <template slot="item.class_id_agent_text" slot-scope="props">
          {{ props.item.request.class_id_agent_text }}
        </template>

        <template slot="item.approve_for_archiving" slot-scope="props">
          {{ status_of_approve(props.item.approve_for_archiving) }}
        </template>

        <template slot="item.request_id" slot-scope="props">
          {{ props.item.request.id }}
        </template>
      </table-component>
    </div>
    <div v-else-if="$store.state.views === 'default'">
      <div v-if="defaultViewData.length > 0">
        <DefaultView
          @pageCount="handlePageNumber"
          :CardData="defaultViewData"
          name="archived_in_quality"
        />
      </div>
      <div>
        <LoadingMore v-if="loadMoreData" style="margin: 40px" />
      </div>
    </div>
    <div v-else-if="$store.state.views === 'cards'">
      <CardsStyle :tableData="items" />
    </div>
    <v-btn
      fab
      :color="$vuetify.theme.themes.light.dialogActionBTN"
      @click="addNewRequestDialog = true"
      class="my-10"
      style="position: fixed; left: 20px; bottom: 30px"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25.425"
        height="21.166"
        viewBox="0 0 25.425 21.166"
      >
        <g
          id="Icon_feather-user-plus"
          data-name="Icon feather-user-plus"
          transform="translate(1 1)"
        >
          <path
            id="Path_2554"
            data-name="Path 2554"
            d="M17.471,28.889v-2.13A4.259,4.259,0,0,0,13.212,22.5H5.759A4.259,4.259,0,0,0,1.5,26.759v2.13"
            transform="translate(-1.5 -9.723)"
            fill="none"
            stroke="#fff"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          />
          <path
            id="Path_2555"
            data-name="Path 2555"
            d="M15.268,8.759A4.259,4.259,0,1,1,11.009,4.5,4.259,4.259,0,0,1,15.268,8.759Z"
            transform="translate(-3.023 -4.5)"
            fill="none"
            stroke="#fff"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          />
          <path
            id="Path_2556"
            data-name="Path 2556"
            d="M30,12v6.389"
            transform="translate(-9.77 -6.676)"
            fill="none"
            stroke="#fff"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          />
          <path
            id="Path_2557"
            data-name="Path 2557"
            d="M31.889,16.5H25.5"
            transform="translate(-8.464 -7.982)"
            fill="none"
            stroke="#fff"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          />
        </g>
      </svg>
    </v-btn>
    <add-new-request
      v-model="addNewRequestDialog"
      width="350px"
      @submitted="get_archieved_requests"
    />
    <!-- <AgentChat /> -->
    <CallsDialog />
    <OrderRequestDialog />

    <v-row justify="center">
      <v-dialog v-model="filterDialog" persistent width="1024">
        <v-card>
          <v-card-title>
            <!-- <span> ابحث الان  </span> -->
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <v-autocomplete
                    :items="['الكل', 'نعم', 'لا']"
                    label=" الموافقه علي الارشفة ؟"
                    v-model="selectedAcceptArchivedOrNot"
                    outlined
                    dense
                  >
                    <template v-slot:item="{ item, attrs, on }">
                      <v-list-item v-bind="attrs" v-on="on">
                        <v-list-item-title
                          :id="attrs['aria-labelledby']"
                          v-text="item"
                        ></v-list-item-title>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                </v-col>

                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    label="الهاتف"
                    v-model="phoneNumber"
                    outlined
                    v-numericOnly
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue-darken-1"
              variant="text"
              @click="dialog = filterDialog = false"
            >
              الغاء
            </v-btn>
            <v-btn
              color="blue-darken-1"
              variant="text"
              @click="searchInArchivedBasket"
            >
              بحث
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>


    <v-snackbar
        v-model="$store.state.showAlertOfArchivedQualityDidntProccess"
        timeout="-1"
        right
        bottom
        class="ml-4"
        elevation="24"
        transition="fade-transition"
        color="red"
    >
      <div>
        <span class="font-weight-bold" style="font-size: 16px">يوجد طلبات فى ارشيف الجودة تحتاج لمعالجة </span>
      </div>
      <template v-slot:action>
        <v-btn icon small @click="$store.state.showAlertOfArchivedQualityDidntProccess = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>

</template>

<script>
import Axios from "axios";
import CardsStyle from "@/components/Base/CardsStyle.vue";
// import AgentChat from "@/components/AgentChat/AgentChat.vue";
import { RequestCallsIcon } from "@/assets/adminIcons/requestCalls";
import { NotAllowIcon } from "@/assets/adminIcons/notAllowIcon";
import CallsDialog from "@/components/Charts/CallsDialog.vue";
import DefaultView from "@/components/Base/DefaultView";
import LoadingMore from "@/components/Charts/LoadingMore";
import OrderRequestDialog from "@/components/AdminComponent/OrderRequestDialog.vue";
import { OrderHistory } from "@/assets/adminIcons/orderHistory";
import { SearchIcon } from "@/assets/adminIcons/searchIcon";
import { axiosInstance } from "@/axios/config";

export default {
  name: "HelloWorld",
  components: {
    CardsStyle,
    // AgentChat,
    RequestCallsIcon,
    // NotAllowIcon,
    CallsDialog,
    DefaultView,
    LoadingMore,
    OrderRequestDialog,
    OrderHistory,
    SearchIcon,
  },
  data: () => ({
    loading: false,
    defaultViewData: [],
    loadMoreData: false,
    headers: [
      { text: "تاريخ الطلب", value: "req_date", width: "120px" },
      { text: "نوع الطلب", value: "type", width: "120px", align: "center" },
      { text: "عميل", value: "customer_name", width: "120px", align: "center" },
      {
        text: "حالة الطلب ",
        value: "status",
        width: "140px",
        align: "center",
      },
      {
        text: "مصدر المعامله",
        value: "source",
        width: "120px",
        align: "center",
      },
      {
        text: "تصنيف المعامله",
        value: "class_id_agent_text",
        width: "120px",
        align: "center",
      },
      {
        text: "الملاحظه",
        value: "agent_notes",
        width: "150px",
        align: "center",
      },
      {
        text: "ملاحظة الجوده",
        value: "quality_notes",
        width: "150px",
        align: "center",
      },
      {
        text: "تاريخ الاستشاري",
        value: "agent_date",
        width: "120px",
        align: "center",
      },
      {
        text: "حالة المعالجة",
        value: "approve_for_archiving",
        width: "120px",
        align: "center",
      },

      { text: "أرشفته", value: "settings", align: "center", width: "150px" },
      { text: "العمليات", value: "action", align: "center" },
    ],
    page: 1,
    items: [],
    selected_requests: [],
    addNewRequestDialog: false,
    pagination: {},
    selectedTab: 2,

    // filter
    filterDialog: false,
    selectedAcceptArchivedOrNot: "الكل",
    phoneNumber: "",
    count_of_proccessed: 0,
    isSearch:false,
  }),
  methods: {
    handlePageNumber(val) {
      this.get_archieved_requests(val);
    },
    get_archieved_requests(page = 1, type = "table") {
      this.$store.state.tableData = []
      this.loading = true;
      Axios.get(
        `${this.$store.state.url}/v2/employee/Requests?type=archived_in_quality&filter_archived_in_quality=${this.selectedTab}&page=${page}&per_page=${this.$store.state.counterOfShow}`,
        {
          headers: this.request_headers(),
        }
      ).then((response) => {
        if (page === 1 || type === "table") {
          this.$store.state.tableData = response.data.payload.data;
        }
        this.defaultViewData.push(...response.data.payload.data);
        // this.items = response.data.payload.data;
        this.pagination = {
          limit: 10,
          count: response.data.payload.count_of_archived_in_quality,
        };
        if (this.selectedTab == 0) {
          this.count_of_proccessed =
            response.data.payload.count_of_archived_in_quality;
        }
        this.loading = false;
      });
    },

    getRequestCalls(item) {
      this.$store.state.idOfRequestCalls = item.request.id;
      this.$store.state.openCallsDialog = true;
    },

    searchInArchivedBasket(page) {
      this.filterDialog = false;
      this.$store.state.tableData = []
      this.$store.state.bodySearch.delete("ApproveForQualityArchived");
      this.loading = true;

      if (this.selectedAcceptArchivedOrNot === "نعم") {
        this.$store.state.bodySearch.append("ApproveForQualityArchived", 1);
      }else if (this.selectedAcceptArchivedOrNot === "لا") {
        this.$store.state.bodySearch.append("ApproveForQualityArchived", 0);
      }

      if (this.phoneNumber) {
        this.$store.state.bodySearch.append("QualityCustomerMobile", this.phoneNumber);
      }

      let url = `/v2/employee/Requests/search?type=archived_in_quality&page=${page}`;
      axiosInstance
        .post(url, this.$store.state.bodySearch)
        .then((res) => {
          this.isSearch = true;
          this.$store.state.tableData = res.data.payload.data;
          this.pagination = {
            limit: 10,
            count: res.data.payload.searched,
          };

          this.loading = false;

        })
        .catch((err) => {});
    },

    status_of_approve(item) {
      if (item == 0) {
        return "تم الرفض";
      } else if (item == 1) {
        return "تمت الموافقه";
      } else {
        return "ف الانتظار";
      }
    },

    tabsFilter(val) {
      this.selectedTab = val;
      this.get_archieved_requests(this.page);
    },

    cancelRequestFromarchived(id) {
      Axios.post(
        `${this.$store.state.url}/v2/employee/RestoreArchivedInQualityRequestToReceived/${id}`,
        {},

        {
          headers: this.request_headers(),
        }
      )
        .then((res) => {
          this.showPopup("success", res.data.message);
          this.selectedTab = 2;
          this.get_archieved_requests(this.page);
        })
        .catch((err) => {
          this.showPopupError("success", err.response.data.message);
        });
    },

    handleFilterRateDialog() {
      this.filterDialog = true;
    },

    approveArchivedRequest(id) {
      Axios.post(
        `${this.$store.state.url}/v2/employee/acceptArchivedInQualityRequest/${id}`,
        {},
        {
          headers: this.request_headers(),
        }
      )
        .then((res) => {
          this.showPopup("success", res.data.message);
          this.selectedTab = 2;
          this.get_archieved_requests(this.page);
        })
        .catch((err) => {
          this.showPopupError("success", err.response.data.message);
        });
    },

    to_tickets_page(item) {
      this.$router.push({ name: "tickets", params: { id: item.request.id } });
    },

    to_chat_page(item) {
      this.$router.push({
        name: "chat_component",
        query: {
          customer_name: item.request.customer.name,
          customer_id: item.request.customer.id,
          request_id: item.request.id,
        },
      });
    },

    toOrderRequest(item) {
      this.$store.state.orderRequestId = item.request.id;
      if (this.$store.state.showCards || this.$store.state.showCards == false) {
        this.$store.state.orderRequestDialog = true;
      } else {
        this.$store.state.openOrderRequestSection = true;
      }
    },

    exportExcel() {
      const table = document.querySelector(".archieved-requests table");
      this.exportTableToCsv(table, "الطلبات المؤرشفة");
    },
    printNow() {
      this.printTable(this.items, this.headers, "جدول الطلبات المؤرشفة");
    },
  },
  created() {
    this.$store.state.views = "table";
    this.$store.state.opened = -1;
    this.get_archieved_requests();
    this.$store.state.bodySearch = new FormData();
    this.$store.state.tableData = [];

  },
  watch: {
    page(val) {
      if (this.isSearch === false) {
        this.get_archieved_requests(val);
      } else {
        this.searchInArchivedBasket(val);
      }
    },

    selected_requests(val) {
      this.$emit("requests", val);
    },

    "$store.state.first_not_processed_task_id": {
      handler(val) {
        if (val > 0 && localStorage["role"] == "0") {
          this.$store.state.showAlertOfTasksDidntProccess = true;
          this.$router.push({ name: 'ticket_details', params: { ticket: this.$store.state.first_not_processed_task_id } });
        }
      },
      immediate: true 
    },

    "$store.state.counterOfShow": {
      handler(newval, oldvalue) {
        if (newval != oldvalue) {
          this.get_archieved_requests(this.page);
        }
      },
    },

    $route: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$store.state.counterOfShow = 10;
        }
      },
    },
  },

  computed: {
    getHeaders() {
      return this.headers.filter(
        (item) => !(item.value === "settings" && this.selectedTab == 0)
      );
    },
  },
};
</script>

<style scoped>
.accept-button {
  margin: 3px;
  background-color: #16bd40;
  color: #fff;
  padding: 3px 5px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.refuse-button {
  background-color: #e61010;
  color: #fff;
  padding: 3px 5px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.accept-button:hover,
.refuse-button:hover {
  background-color: #2980b9;
}

.custom-tabs {
  border-bottom: 1px solid #ccc; /* Set your desired border color */
}

.custom-tab {
  color: rgb(10, 10, 10); /* Set your desired text color */
  font-weight: bold;
  transition: background-color 0.3s ease; /* Add transition for a smooth effect */
}

.custom-tab--active {
  color: #0a0a0a; /* Set text color for the selected tab */
}
</style>
